import React, { useEffect, useState } from "react";
import axiosInstance from "../axios/axios";
import Loader from "./Loader";

const CompanyNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const user_id = localStorage.getItem("user_id");
  const fetchNotifications = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`view_notifications/${user_id}`);
      console.log(response.data.notifications);
      setNotifications(response.data.notifications);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchNotifications();
  }, []);
  if (loading) return <Loader />;
  return (
    <div className="m-6 flex flex-col gap-4 ">
      {notifications.map((notification, index) => (
        <div
          className="bg-[#F3F3F4] rounded-xl p-3 flex flex-col gap-2"
          key={index}
        >
          <span className="font-bold">{notification.title}</span>
          <span>{notification.message}</span>
        </div>
      ))}
    </div>
  );
};

export default CompanyNotifications;
